import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-sort2-icon',
  templateUrl: './shopping-sort2.component.html'
})
export class ShoppingSort2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
